import type { CityConfig } from "@/pages/city-template/types";

export const rochesterConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Rochester",
  state: "New York",
  stateAbbr: "NY",
  slug: "rochester",
  route: "/rochester",
  title: "Emergency Passport Rochester, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Rochester, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving RIT students, UR researchers, Xerox and L3Harris professionals, and Monroe County families.",
  h1: "Emergency & Expedited Passport Services in Rochester, NY",
  heroSubtitle: "RIT co-op in Germany departing in 8 days? UR Medical conference in Geneva next week? L3Harris contract trip to the UK with 5 days notice? We help Rochester residents — from Park Avenue professionals to Brighton families to Henrietta tech workers — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20panoramic%20view%20of%20downtown%20Rochester%20New%20York%20skyline%20at%20golden%20hour%20with%20the%20Genesee%20River%20and%20High%20Falls%20waterfall%20in%20the%20foreground%2C%20historic%20brick%20buildings%20and%20modern%20glass%20architecture%2C%20Kodak%20Tower%20visible%20in%20the%20distance%2C%20dramatic%20sunset%20clouds%20reflecting%20warm%20amber%20light%2C%20clean%20urban%20landscape%20with%20autumn%20foliage%20along%20the%20river%20gorge%2C%20professional%20architectural%20photography%20with%20rich%20warm%20tones%2C%20no%20readable%20text%20or%20signs&width=1800&height=700&seq=rochester-ny-hero-2026&orientation=landscape",
  heroImageAlt: "Rochester New York skyline with Genesee River and High Falls at golden hour",
  geoPosition: "43.1566;-77.6088",
  geoPlacename: "Rochester, New York",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Buffalo Passport Agency",
    address: "111 Genesee Street Suite 101, Buffalo, NY 14203",
    distance: "~75 miles from Rochester — our courier eliminates the need to drive to Buffalo",
  },
  nearbyCitiesZips: [
    { name: "Rochester", zips: "14602–14627, 14638, 14639, 14642–14647, 14649–14653, 14692, 14694" },
    { name: "Greece", zips: "14612, 14615, 14616, 14626" },
    { name: "Irondequoit", zips: "14609, 14617, 14621, 14622" },
    { name: "Brighton", zips: "14610, 14618, 14620, 14623, 14625" },
    { name: "Henrietta", zips: "14467, 14586, 14623" },
    { name: "Penfield", zips: "14526, 14625" },
    { name: "Webster", zips: "14580" },
    { name: "Perinton", zips: "14450" },
    { name: "Pittsford", zips: "14534" },
    { name: "Gates", zips: "14606, 14624" },
    { name: "Chili", zips: "14624" },
    { name: "Brockport", zips: "14420" },
    { name: "Victor", zips: "14564" },
    { name: "Canandaigua", zips: "14424, 14425" },
    { name: "Batavia", zips: "14020, 14021" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the Buffalo Passport Agency — as fast as 24 hours for Rochester-area travelers with immediate departures." },
    { icon: "ri-flight-takeoff-line", title: "ROC Airport Expertise", desc: "Greater Rochester International Airport connects to all major U.S. hubs. We know airline schedules, winter weather delays, and connecting flight timing for international itineraries." },
    { icon: "ri-graduation-cap-line", title: "RIT, UR & College Expedited", desc: "RIT, University of Rochester, Nazareth, St. John Fisher, MCC — we guide students and faculty through study abroad, co-op, and conference passport timelines." },
    { icon: "ri-building-2-line", title: "Tech & Optics Industry Ready", desc: "L3Harris, Xerox, Carestream, Bausch + Lomb, Corning Tropel — optics and imaging professionals on short-notice international contracts. We handle it." },
  ],
  internalLinks: [
    { name: "Fast passport services in New York City", route: "/new-york-city" },
    { name: "Expedited passport in Buffalo, NY", route: "/buffalo" },
    { name: "Quick passport services in Syracuse, NY", route: "/syracuse" },
    { name: "Urgent passport services in Albany, NY", route: "/albany-ny" },
    { name: "New York State passport services overview", route: "/new-york" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Rochester via secure registered courier with direct access to the Buffalo Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without the 75-mile drive to Buffalo. Rochester residents can ship from any UPS Store, FedEx Office, or post office location across Monroe County.",
  fpcOfficeDistance: "Serving Rochester, Greece, Irondequoit, Brighton, Henrietta, and all Monroe County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Rochester and all of Monroe County. From the East End and Park Avenue to the suburbs of Greece and Irondequoit, from the college towns of Henrietta and Brighton to the Finger Lakes communities of Pittsford and Victor — we serve all of greater Rochester. Our courier service eliminates the need to drive 75 miles to the Buffalo Passport Agency.",
  nearbyCitiesIntro: "We serve Rochester and all Monroe County communities including Greece, Irondequoit, Brighton, Henrietta, Penfield, Webster, Perinton, Pittsford, Gates, Chili, Brockport, Victor, and Canandaigua. We also serve travelers departing from Greater Rochester International Airport who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Rochester as simple as possible — with the efficiency and reliability RIT co-op students, UR Medical researchers, optics industry engineers, and Monroe County families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Rochester travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Rochester travelers encounter unique passport issues — everything from RIT co-op deadlines to optics industry supplier audit travel. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Rochester travelers — from Park Avenue professionals to Henrietta families to L3Harris engineers — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Rochester, NY? Here are the most common ones we hear from Monroe County travelers.",
  statePageRoute: "/new-york",
  statePageName: "New York",
  servicesIntro: "Whether you need a renewal before a ROC flight to a connecting hub, an emergency passport for a last-minute optics industry trip, or a first-time passport for an RIT student heading abroad — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingIntro: "Rochester travelers — RIT students on international co-ops, UR Medical researchers at global conferences, L3Harris and Xerox engineers on supplier visits, and Monroe County families flying out of ROC to connect through hubs — have several options for getting a passport fast. Here is how they compare, and why most Rochester residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the 75-mile drive to the Buffalo Passport Agency.",
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission — no 330-mile drive needed", "Ideal for RIT co-op students heading to Germany or Japan", "Perfect for UR Medical researchers at international conferences", "Great for L3Harris engineers on overseas contract visits", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service at Rochester post offices", "Good for planned international trips from ROC", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required at Monroe County facilities", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required at Buffalo Passport Agency — 75 miles away in downtown Buffalo", "No walk-ins accepted at any regional agency", "Life-or-death emergencies only — bereavement or medical crisis", "Must prove travel within 72 hours with printed itinerary", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "L3Harris contract trip to London this week? RIT co-op in Munich departing in days? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Rochester-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Rochester residents renew fast — no agency visit required for most renewals. Perfect for Park Avenue professionals, Brighton families, and Monroe County commuters.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Rochester residents through every step — from downtown to Greece to Henrietta — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your optics industry trip or ROC connecting flight stays on schedule.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Monroe County family vacation to the Caribbean or Europe stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Rochester professionals after life changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for L3Harris engineers, Xerox executives, and UR researchers who travel while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Monroe County travelers through the process so your international plans stay on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Popular with Rochester residents visiting Toronto (3 hours away via I-90).",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Rochester NY", description: "Urgent passport processing for Rochester New York travelers with immediate departure needs from ROC Airport." },
    { name: "Expedited Passport Renewal Rochester NY", description: "Fast passport renewal for Rochester New York residents with a previously-issued passport." },
    { name: "First-Time Passport Rochester NY", description: "New passport application services for Rochester New York residents applying for their first passport." },
    { name: "Child Passport Rochester NY", description: "Minor passport services for Rochester New York families with children under 16." },
    { name: "Name Change Passport Rochester NY", description: "Passport name correction after marriage, divorce, or legal name changes for Rochester residents." },
    { name: "Second Passport Rochester NY", description: "Second passport services for Rochester tech and optics industry professionals and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Michael R.",
      location: "Park Avenue, Rochester",
      rating: 5,
      text: "L3Harris sent me to a supplier audit in the UK with one week notice and my passport had expired 3 months ago. Fast Passport Center got my renewal back in 48 hours. The document review caught a photo issue I would have missed at the post office.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Chen Family",
      location: "Brighton",
      rating: 5,
      text: "Our son got accepted to an RIT co-op in Germany with just 3 weeks before the start date. First passport ever. They guided us through the DS-11 at the Brighton post office and the passport arrived in 5 days. He made his co-op orientation.",
      service: "New Passport",
    },
    {
      name: "Jennifer L.",
      location: "Henrietta",
      rating: 5,
      text: "UR Medical researcher here — had a paper accepted at a conference in Geneva and needed a name change on my passport after getting married. They handled everything remotely and the new passport arrived in 4 days. No office visit, no stress.",
      service: "Name Change Passport",
    },
    {
      name: "David K.",
      location: "Irondequoit",
      rating: 5,
      text: "Booked a family trip to Italy and realized our son's passport only had 4 months left — Fast Passport Center flagged the 6-month Schengen rule immediately and got his renewal done in 5 days. We made our flight to Rome with days to spare.",
      service: "Child Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "roc-1",
      name: "Rochester Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1335 Jefferson Rd",
      city: "Rochester",
      state: "NY",
      zip: "14623",
      phone: "(585) 272-0743",
      hours: "Mon–Fri 8:00 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      distance: "Henrietta — Monroe County",
      website: "https://tools.usps.com/find-location.htm?location=1367618",
      websiteLabel: "USPS Location",
      notes: "Rochester's primary passport acceptance facility. Photo services on-site. Busiest facility in Monroe County — book appointments 2+ weeks ahead during peak travel seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "roc-2",
      name: "Downtown Rochester Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 State St",
      city: "Rochester",
      state: "NY",
      zip: "14614",
      phone: "(585) 232-5671",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Downtown Rochester",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Convenient for downtown workers and Park Avenue residents. No weekend hours. Passport photos not available on-site — bring your own.",
      icon: "ri-mail-line",
    },
    {
      id: "roc-3",
      name: "Greece Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3245 Latta Rd",
      city: "Rochester",
      state: "NY",
      zip: "14612",
      phone: "(585) 225-0370",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Greece — North Suburbs",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serves Greece, Charlotte, and northern Rochester neighborhoods. Passport photos available. Saturday appointments fill quickly.",
      icon: "ri-mail-line",
    },
    {
      id: "roc-4",
      name: "Monroe County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "39 W Main St",
      city: "Rochester",
      state: "NY",
      zip: "14614",
      phone: "(585) 753-1600",
      hours: "Mon–Fri 9:00 AM – 4:30 PM",
      distance: "Downtown Rochester — County Office Building",
      website: "https://www.monroecounty.gov/clerk",
      websiteLabel: "Monroe County Clerk",
      notes: "County-operated passport acceptance. Also handles marriage license records for name change documentation. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "roc-5",
      name: "Irondequoit Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "450 East Ridge Rd",
      city: "Rochester",
      state: "NY",
      zip: "14621",
      phone: "(585) 342-3401",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Irondequoit — North of Downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serves Irondequoit and northeast Rochester. Limited walk-in availability — call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "roc-6",
      name: "Penfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2080 Fairport Nine Mile Point Rd",
      city: "Penfield",
      state: "NY",
      zip: "14526",
      phone: "(585) 377-5980",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Penfield — East Suburbs",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Eastern Monroe County option for Penfield, Webster, and Perinton residents. Appointment recommended.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out at NYC agency, 330 miles away", fpc: "No appointment needed to start — ship from home" },
    { feature: "In-Person Visit", agency: "Required — drive to the Buffalo Passport Agency in downtown Buffalo", fpc: "Most Rochester travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel within 72 hours", fpc: "As fast as 24 hours — multiple speed options available" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay of 2+ weeks", fpc: "Professional review to catch photo issues, form errors, and missing signatures" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only on tight eligibility", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee of service", fpc: "Predictable processing based on selected speed option with guaranteed turnaround" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation, no travel proof needed" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle 330-mile drive and all logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Rochester-Specific Guidance", agency: "Generic — no RIT/UR, optics industry, or Monroe County expertise", fpc: "Full RIT/UR/optics industry/Monroe County knowledge built into our service" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "RIT Co-op Acceptance-to-Departure Crunch",
      description: "RIT students often receive co-op placement confirmations with 3–6 weeks before their international start date. Standard post office processing takes 8–11 weeks. Expedited courier service is the only reliable path for most RIT co-op students heading to Germany, Japan, or the UK.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Rochester applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations at Local Pharmacies",
      description: "Many Rochester-area CVS and Walgreens locations produce photos that fail State Department standards — wrong background shade, incorrect head size, or shadows. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Monroe County families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection for child passports — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for Schengen 6-Month Rule",
      description: "Rochester travelers to Italy, Germany, France, and other EU destinations often don't know their passport must have 6 months remaining beyond the return date. We flag this immediately — critical for RIT co-op students on 6-month placements.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or RIT/UR dorm." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Rochester clients ship from home or a nearby UPS Store — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 330 miles to Manhattan or wait for a post office appointment." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Rochester?", a: "We offer Rochester-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 2–9 business days. We review your documents before submission to catch errors that cause delays — especially important for RIT co-op students and optics industry professionals on tight timelines." },
    { q: "Do I need to visit a Rochester office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (a Rochester-area post office or the Monroe County Clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Rochester address." },
    { q: "Where can I get passport acceptance in Rochester?", a: "Rochester has acceptance facilities at the Main Post Office on Jefferson Road, the Downtown Post Office on State Street, the Greece Post Office on Latta Road, and the Monroe County Clerk on West Main Street. We maintain an updated list with hours, photo availability, and appointment options." },
    { q: "Does the Buffalo Passport Agency serve Rochester walk-ins?", a: "The Buffalo Passport Agency (111 Genesee Street Suite 101, downtown Buffalo, 75 miles from Rochester) requires appointments for life-or-death emergency travel only. Walk-ins are rarely accepted. For travel within 3–14 days, our registered courier service is the fastest legally available channel without the 5+ hour drive." },
    { q: "What is the best price for expedited passport service in Rochester?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "Can you help RIT students with co-op passports?", a: "Yes. RIT sends hundreds of students on international co-ops annually — to Germany, Japan, the UK, Singapore, and beyond. Co-op acceptance-to-departure is often just 3–6 weeks. We guide RIT students through the entire passport process, including first-time applications and expedited renewals." },
    { q: "Can I get a passport photo in Rochester?", a: "Yes — many Rochester-area CVS, Walgreens, UPS Stores, and FedEx Office locations offer passport photos. The Rochester Main Post Office on Jefferson Road also provides photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How does ROC Airport connect for international travel?", a: "Greater Rochester International Airport connects to Atlanta, Charlotte, Chicago, Detroit, New York, and Washington-Dulles, providing one-stop access to virtually every international destination. Airlines verify passport validity at ROC check-in for any international itinerary — even if your first flight is domestic." },
    { q: "Can you help with UR Medical international conference passports?", a: "Yes. University of Rochester Medical Center faculty and researchers travel to international conferences worldwide — often with only 2–4 weeks notice after paper acceptance. We handle the expedited passport so you can focus on your presentation." },
    { q: "What about Toronto access from Rochester?", a: "Rochester is just 3 hours from Toronto via I-90 and the Lewiston-Queenston Bridge. Many Rochester residents visit Toronto for weekend trips or Pearson Airport for international flights. A valid passport book is required for air travel to Canada — enhanced licenses do not work at airports." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Rochester Residents",
    intro: "Rochester's position as an optics and imaging hub with world-class universities and a regional connector airport creates distinct passport timing challenges. Here's what Rochester travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "ROC — Greater Rochester International Airport",
        subtitle: "Monroe County's primary airport, hub connections to global destinations",
        description: "Greater Rochester International Airport connects Monroe County to Atlanta, Charlotte, Chicago, Detroit, New York, and Washington-Dulles, providing one-stop access to international destinations worldwide. The airport handles 2M+ passengers annually. ROC's spoke-to-hub model means Rochester travelers must have valid passports at check-in — airlines verify documents for the full international itinerary.",
        tip: "ROC's early morning flights connect to afternoon international departures at hubs. If your passport is flagged at ROC check-in, you miss your connection. Always check passport validity at least 3 weeks before any international itinerary from ROC.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "RIT & UR — Study Abroad and International Co-ops",
        subtitle: "RIT co-op programs in 60+ countries, UR research across the globe",
        description: "RIT's renowned co-op program sends hundreds of students abroad each year to Germany, Japan, the UK, Singapore, and beyond. University of Rochester researchers travel to international conferences and collaborations across six continents. Many students — especially first-generation college students — have never held passports and face tight 3–6 week acceptance-to-departure windows for co-op placements.",
        tip: "RIT co-op acceptance letters arrive with 3–6 weeks before the start date. First-time passport applicants need an acceptance facility visit — we help students find the nearest available appointment so they don't miss their co-op orientation.",
      },
      {
        icon: "ri-building-2-line",
        title: "Optics & Imaging Industry Travel",
        subtitle: "L3Harris, Xerox, Carestream, Bausch + Lomb, Corning Tropel",
        description: "Rochester's identity as the world capital of optics and imaging creates significant international business travel. L3Harris engineers travel for defense and communications contracts. Xerox and Carestream professionals attend global imaging conferences. Bausch + Lomb executives travel for international operations. These trips often materialize on short notice — supplier audits, contract signings, and technical deployments with 5–10 days of lead time.",
        tip: "Optics industry travel to Germany (OPTATEC, LASER World of PHOTONICS), Japan, and the UK often requires 6-month passport validity. If you work in Rochester's optics sector, keep your passport renewed proactively.",
      },
      {
        icon: "ri-flag-line",
        title: "Cross-Border Canada Access & Toronto Pearson",
        subtitle: "3 hours to Toronto, 1.5 hours to Niagara Falls border crossings",
        description: "Rochester's proximity to Canada makes cross-border travel routine. Toronto is a 3-hour drive via the I-90 and QEW. The Lewiston-Queenston Bridge and Rainbow Bridge (Niagara Falls) are 1.5 hours away. Many Rochester residents use Toronto Pearson (YYZ) for international flights offering significantly lower fares than U.S. connections. Enhanced driver's licenses work for land crossings but NOT for air travel to or within Canada.",
        tip: "If you fly from Toronto Pearson (YYZ) to Europe or Asia, you need a valid passport book. Many Rochester travelers learn this at the YYZ check-in counter. Enhanced licenses and passport cards will not get you on the plane.",
      },
    ],
    callout: {
      icon: "ri-snowy-line",
      title: "Rochester Winters & Snowbird Season",
      description: "Rochester's legendary lake-effect snow (100+ inches annually) drives a predictable winter escape season from January through March. Thousands of Monroe County residents flee to Florida, the Caribbean, and Mexico — often discovering expired passports while packing. Plan ahead: check your passport in October, before the snow starts falling.",
    },
  },
  destinations: {
    title: "Where Rochester Travelers Go — And Why Passports Get Urgent",
    intro: "Rochester's optics industry, world-class universities, and proximity to Canada shape where Monroe County residents travel. Here are the most common international destinations and the urgency patterns we see.",
    stats: [
      { stat: "42%", label: "of Rochester expedited requests are university-related — RIT co-ops, UR research, study abroad" },
      { stat: "3–6 Weeks", label: "average lead time from RIT co-op acceptance to international departure" },
      { stat: "Jan–Mar", label: "peak snowbird season — Caribbean, Florida, and Mexico bookings collide with spring semester co-ops" },
      { stat: "36 Hours", label: "shortest turnaround for an L3Harris engineer departing to the UK" },
    ],
    destinations: [
      { name: "Germany", context: "RIT co-op placements in Munich, Berlin, and Stuttgart; optics industry conferences; UR research collaborations with Max Planck institutes", urgency: "RIT co-op acceptance letters arrive 3–6 weeks before start date; industry travel booked 1–3 weeks out", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom", context: "L3Harris and BAE Systems contract travel; RIT London programs; UR exchange partnerships; family heritage trips", urgency: "Defense industry trips booked on short notice; academic programs lock in 8–10 weeks before departure", icon: "ri-map-pin-2-line" },
      { name: "Japan", context: "Optics industry supplier meetings in Tokyo and Osaka; RIT co-ops with Japanese tech companies; academic collaborations", urgency: "Business travel often has 1–2 week booking windows; strict 6-month passport validity enforced", icon: "ri-map-pin-2-line" },
      { name: "Italy & France", context: "RIT and UR study abroad programs in Florence, Rome, and Paris; optics industry trade shows; Finger Lakes wine industry exchange programs", urgency: "Study abroad acceptance-to-departure is 6–10 weeks; first-time passports needed for many students", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Toronto weekend getaways (3 hours by car), Pearson Airport international departures, Montreal tourism, cross-border family connections", urgency: "Weekend trips booked impulsively; enhanced licenses work for land but NOT air", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Mexico", context: "ROC-MCO/ATL-Caribbean connections, snowbird escapes during Rochester's brutal January–March winter, spring break for RIT and UR students", urgency: "Winter escape bookings spike December–January as lake-effect snow piles up", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other New York Service Areas",
    crossLinksDesc: "We serve travelers across the Empire State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "New York City", route: "/new-york-city" },
      { name: "Buffalo", route: "/buffalo" },
      { name: "Syracuse", route: "/syracuse" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Monroe Ave", address: "2100 Monroe Ave, Rochester, NY 14618", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Lake Ave", address: "1300 Lake Ave, Rochester, NY 14613", hours: "Daily 7 AM – 11 PM", website: "https://www.walgreens.com/photo" },
    { name: "FedEx Office — Henrietta", address: "1100 Jefferson Rd, Rochester, NY 14623", hours: "Mon–Fri 7 AM – 9 PM, Sat 8 AM – 6 PM", website: "https://www.office.fedex.com/default/office" },
    { name: "UPS Store — Pittsford Plaza", address: "3349 Monroe Ave, Rochester, NY 14618", hours: "Mon–Fri 8 AM – 7 PM, Sat 9 AM – 5 PM", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "CVS Pharmacy — Greece", address: "2300 W Ridge Rd, Rochester, NY 14626", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Penfield", address: "2160 Penfield Rd, Penfield, NY 14526", hours: "Daily 7 AM – 11 PM", website: "https://www.walgreens.com/photo" },
    { name: "Walmart Photo Center — Henrietta", address: "1200 Marketplace Dr, Rochester, NY 14623", hours: "Daily 7 AM – 10 PM", website: "https://www.walmart.com/" },
    { name: "Rite Aid — Irondequoit", address: "600 East Ridge Rd, Rochester, NY 14621", hours: "Daily 8 AM – 10 PM", website: "https://www.riteaid.com/" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Rochester (Henrietta)",
      address: "2199 E Henrietta Rd, Rochester, NY 14623",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Rochester's busiest DMV. REAL ID, driver's license renewals, and enhanced licenses available. Appointment strongly recommended — walk-in wait times can exceed 2 hours.",
      featured: true,
    },
    {
      name: "NYS DMV — Greece",
      address: "152 Greece Ridge Center Dr, Rochester, NY 14626",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Northwest suburbs DMV serving Greece, Charlotte, and Parma. REAL ID processing available.",
      featured: false,
    },
    {
      name: "NYS DMV — Irondequoit",
      address: "545 Titus Ave, Rochester, NY 14617",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Northeast suburbs DMV serving Irondequoit, Webster, and Penfield. Convenient for lakeshore residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ROC",
      name: "Greater Rochester International Airport",
      distance: "4 miles southwest of downtown Rochester",
      address: "1200 Brooks Ave, Rochester, NY 14624",
      note: "Monroe County's primary airport with direct flights to Atlanta, Charlotte, Chicago, Detroit, New York, and Washington-Dulles. One-stop connections to international destinations worldwide. 2M+ annual passengers.",
      flightUrl: "https://www.flyrga.com/",
      flightLabel: "Rochester Airport",
      featured: true,
    },
    {
      code: "BUF",
      name: "Buffalo Niagara International Airport",
      distance: "70 miles from Rochester",
      address: "4200 Genesee St, Buffalo, NY 14225",
      note: "Western alternative with seasonal international flights. Useful for Rochester travelers when ROC routes are fully booked.",
      flightUrl: "https://www.buffaloairport.com/",
      flightLabel: "Buffalo Airport",
      featured: false,
    },
    {
      code: "SYR",
      name: "Syracuse Hancock International Airport",
      distance: "80 miles from Rochester",
      address: "1000 Col Eileen Collins Blvd, Syracuse, NY 13212",
      note: "Eastern alternative with domestic hub connections. Good backup option when ROC flights are limited.",
      flightUrl: "https://www.syrairport.org/",
      flightLabel: "Syracuse Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New York State Department of Health. Online, mail, or in-person options available for Monroe County births.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through NYSDOH Vital Records. Required for estate and legal matters in Monroe County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Monroe County Clerk at 39 W Main Street. Certified copies for name changes and passport corrections.",
      url: "https://www.monroecounty.gov/clerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Monroe County Supreme Court. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/courts/7jd/monroe/",
    },
  ],
};

export default rochesterConfig;